import React from 'react'
import { UiGetCustomer, documentation as UiGetCustomerDoc } from "./uiGetCustomer";
import { UiDevice, documentation as UiAddDeviceDoc } from './uiDevice';
import StepManager from '../components/stepManager';
import { Redirect } from 'react-router-dom';
import { renderReport } from '../components/elementList';
import { UiGetFieldEntities, documentation as UiGetFieldEntitiesDoc } from "./uiGetFieldEntities"

let documentation = {

    title: "New Device",
    subtitle: 'Adds a new device to Thingsboard Acuadori',
    brief: <p>Adds a new device to Thingsboard, linking its EntityViews to chosen Customer and chosen Field.</p>,
    content: <p>
        <p><span className="text-warning">WARNING:</span> Pre-condition: customers should be already present in Thingsboard.</p>
        <p><span className="text-warning">WARNING:</span> Pre-condition: The Fields EntityViews should be already present in Thingsboard.</p>
                In the <i>Choose Customer</i> step, a customer is selected and the device will be related to each Acuadori customer types.
                In the <i>Choose Field</i> step the Fields EntityViews are selected to be related to the corresponding Device's
                EntityViews, one per Acuadori customer type.
                In the <i>Add Device</i> step, the device's name and attributes can be inserted and saved. One EntityView per customer type
                is created too.
                <p><b>All EntityViews are assigned and linked</b> through a relation to the corresponding <b>customer type.</b></p>
        <p><b>All EntityViews are assigned and linked</b> through a relation to the corresponding <b>field type.</b></p>
        <p>The device <b>is not assigned nor related</b> to the customer nor the field.</p>
    </p>,

    steps: [
        { id: 0, ...UiGetCustomerDoc },
        { id: 1, ...UiGetFieldEntitiesDoc },
        { id: 2, ...UiAddDeviceDoc },
    ]
};

class UiAddDevice extends React.Component {

    static defaultProps = {
        FIELDTYPE: 'acuadori field',
    };
    constructor(props) {
        super(props)

        this.customerService = this.props.services.customer;
        this.deviceService = this.props.services.device;

        this.stepManagerRef = React.createRef();
        this.state = {
            finished: false,
            nextRoute: this.props.nextRoute,
            dashboardName: '',

            selectedCustomer: {},
            selectedField: {},
            deviceData: {}

        };
    }

    stepManagerAdvance = () => {
        const element = this.stepManagerRef.current;
        element.advance();
    };
    renderAlert = (message, variant) => {
        this.stepManagerRef.current.showAlert(message, variant);
    };
    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };

    documentation = (title) => {
        if (!title) { return documentation; }

        let doc = documentation;
        documentation.title = title;
        return doc;
    }


    renderGetCustomer = () => {
        return (
            <UiGetCustomer
                error={this.handleSubmitError}
                services={{ customer: this.customerService }}
                finished={(customerData, customerReport) => {
                    this.setState({ selectedCustomer: customerData });
                    this.stepManagerAdvance();
                }
                } />
        );
    }

    renderGetField = () => {
        let { selectedCustomer } = this.state;
        if (!selectedCustomer.instances) {
            return null;
        }

        let { instances } = selectedCustomer;
        return (
            <div>
                <UiGetFieldEntities
                    services={{
                        customer: this.props.services.customer,
                    }}
                    customerList={instances}
                    fieldBaseName={this.props.FIELDTYPE}
                    error={this.handleSubmitError}
                    finished={(fieldData, report) => {
                        this.setState({ selectedField: fieldData });
                        this.stepManagerAdvance();
                    }}
                />
            </div>
        );
    }


    renderAddDevice = () => {
        if (this.state.selectedField.length === 0) {
            return null;
        }
        return (
            <UiDevice
                services={{
                    device: this.props.services.device,
                    customer: this.props.services.customer,
                }}
                customerField={this.state.selectedField}
                finished={(data, report) => {
                    this.setState({
                        deviceData: { data: data, report: report }
                    },
                        this.stepManagerAdvance
                    );

                }}
            />
        );
    }

    reportAllComponentData = () => {
        return this.state.deviceData.report;
    }

    render() {
        let { title } = this.props;
        let { deviceData, finished } = this.state;
        let documentation = this.documentation(title);
        if (!finished) {
            return (
                <div className="container-fluid">
                    <StepManager ref={this.stepManagerRef}
                        alert={{ active: true }}
                        startStepId={0} endStepId={2}
                        onFinished={() => {
                            //window.open( this.props.links.thingsboardRoutes.dashboards );
                            this.setState({ finished: true },
                                this.stepManagerAdvance());
                        }}
                        stepList={[
                            {
                                stepId: 0, stepName: documentation.steps[0].title, formValue: this.renderGetCustomer,
                                documentation: documentation.steps[0]
                            },
                            {
                                stepId: 1, stepName: documentation.steps[1].title, formValue: this.renderGetField,
                                documentation: documentation.steps[1]
                            },
                            {
                                stepId: 2, stepName: documentation.steps[2].title, formValue: this.renderAddDevice,
                                dataValue: () => renderReport(deviceData.report),
                                documentation: documentation.steps[2]
                            },
                        ]}

                        documentation={documentation}
                    />

                </div>
            );
        } else {
            return (
                <div className="container-fluid">
                    {this.state.finished && <Redirect to={this.state.nextRoute} />}
                    {renderReport(deviceData.report)}
                </div>
            )
        }
    }
}


export default UiAddDevice;
export {UiAddDevice, documentation}